import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

//Authguard will authenticate user if not loggedIn will redirect to signin page
const AuthGuard = ({ component }: { component: any }) => {
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	const pathName = window.location.pathname;

	useEffect(() => {
		const profile =
			localStorage.getItem('profile') &&
			JSON.parse(localStorage.getItem('profile')!);

		if (profile?.token) {
			if (
				component.type.name === 'SignIn' ||
				component.type.name === 'SignUp' ||
				component.type.name === 'ForgotPassword'
			) {
				profile?.role !== 1
					? navigate('/dashboard')
					: navigate('/admin/dashboard');
			}
		}

		!profile?.token && navigate('/');
		setLoading(false);
	}, [component]);

	return <>{!loading && component}</>;
};

export default AuthGuard;
